const en = {
  // ── Header nav ──────────────────────────────────────────────────────────────
  nav: {
    home: 'HOME',
    collections: 'COLLECTIONS',
    allCollections: 'All collections',
    bathroom: 'BATHROOM',
    sanitaryAppliances: 'Sanitary appliances',
    bathroomFurniture: 'Bathroom furniture',
    faucets: 'Faucets & Taps',
    showerSystems: 'Shower systems',
    complementaryProducts: 'Complementary products',
    bathroomAccessories: 'Bathroom accessories',
    kitchens: 'KITCHENS',
    seeAll: 'See all',
    joinery: 'JOINERY',
    pvcDoors: 'PVC Doors & Windows',
    aluDoors: 'ALU Doors & Windows',
    rollerShutters: 'Roller Shutters',
    guillotineSystems: 'Guillotine Systems',
    garageDoors: 'Garage Doors',
    entryDoors: 'Entry Doors',
    mosquitoNets: 'Mosquito Nets',
    glassSolutions: 'Glass Solutions',
    pivotDoors: 'Aderka Pivot Doors',
    exterior: 'EXTERIOR',
    pergolas: 'Pergolas',
    sunProtection: 'Sun Protection',
    catalogues: 'CATALOGUES',
    realizations: 'PROJECTS',
    contact: 'CONTACT',
  },

  // ── Footer ───────────────────────────────────────────────────────────────────
  footer: {
    tagline: 'The art of refined living',
    showroom: 'SHOWROOM',
    byAppointment: 'By appointment only',
    contact: 'CONTACT',
    followUs: 'FOLLOW US',
    rights: '© 2025 SRA Global Trading. All rights reserved.',
  },

  // ── HomePage ─────────────────────────────────────────────────────────────────
  home: {
    expertises: 'OUR EXPERTISE',
    expertisesSubtitle: 'Excellence in every detail',
    explore: 'EXPLORE',
    cta: {
      title: "LET'S BRING YOUR VISION TO LIFE",
      text: 'Our team of experts guides you through the creation of your custom project',
      button: 'BOOK AN APPOINTMENT',
    },
    viewAllCollections: 'View all our collections',
  },

  // ── Collections page ─────────────────────────────────────────────────────────
  collections: {
    title: 'Tile Collections — 244 Collections',
    ourCollections: 'OUR COLLECTIONS',
    searchPlaceholder: 'Search...',
    category: 'Category',
    allCategories: 'All categories',
    collection: 'Collection',
    allCollections: 'All collections',
    size: 'Size',
    allSizes: 'All sizes',
    material: 'Material',
    allMaterials: 'All materials',
    filters: 'Filters',
    clear: 'Clear',
    close: 'Close',
    noResults: 'No products match your criteria.',
    clearFilters: 'Clear filters',
    productsFound_one: '{{count}} product found',
    productsFound_other: '{{count}} products found',
  },

  // ── Collection detail page ───────────────────────────────────────────────────
  collectionDetail: {
    back: 'Back to collections',
    home: 'Home',
    viewRender: 'View render',
    documents: 'Documents',
    file: 'File',
    viewAll: 'View all our collections',
    similarCollections: 'Similar collections',
    surface: 'Surface',
    size: 'Size',
    color: 'Color',
    finish: 'Finish',
    availableProducts: 'Available products',
    applications: 'Applications',
    about: 'About',
    aboutText: 'The {{name}} collection combines contemporary aesthetics with technical performance. Available in multiple formats and colours, it adapts to all your indoor and outdoor spaces.',
    specs: 'Specifications',
    otherCollections: 'OTHER COLLECTIONS',
    notFound: 'Collection not found',
    enlargedView: 'Enlarged view',
    breadcrumbCollections: 'Collections',
    collectionLabel: 'Collection',
    viewsCount: '{{count}} views',
    facesCount: '{{count}} faces',
    viewLabel: 'View',
  },

  // ── Generic ──────────────────────────────────────────────────────────────────
  common: {
    back: 'Back',
    home: 'Home',
    search: 'Search...',
    searchProduct: 'Search a product...',
    viewCatalogue: 'View catalogue',
    viewModel: 'View model',
    viewLarge: 'View full size',
    download: 'Download',
    contact: 'contact us',
  },

  // ── Category names (used in data) ────────────────────────────────────────────
  categories: {
    'Carrelage': 'Tiles',
    'Sanitaire': 'Sanitary',
    'Cuisine': 'Kitchen',
    'Menuiserie': 'Joinery',
    'Extérieur': 'Exterior',
    'Salle de bain': 'Bathroom',
    'Intérieur': 'Interior',
    'Extérieur pierre': 'Exterior stone',
  },

  // ── Room categories (roomCategoriesData) ─────────────────────────────────────
  roomCategories: {
    sectionTitle: 'SPACES BY USE',
    sectionSubtitle: 'Bespoke solutions for every environment',
    'Cuisine': 'Kitchen',
    'Salle de Bain': 'Bathroom',
    'Intérieur': 'Interior',
    'Extérieur': 'Exterior',
    'Jardin': 'Garden',
    'Terrasse': 'Terrace',
  },

  // ── Product categories (productCategoriesData) ────────────────────────────────
  productCategories: {
    'Cuisines sur Mesure': 'Custom Kitchens',
    'Appareils Sanitaires': 'Sanitary Appliances',
    'Meubles de Salle de Bain': 'Bathroom Furniture',
    'Robinetterie de Luxe': 'Luxury Faucets',
    'Systèmes de Douche': 'Shower Systems',
    'Produits Complémentaires': 'Complementary Products',
    'Accessoires de Bain': 'Bath Accessories',
    'Menuiserie': 'Joinery',
    'Extérieur & Pergolas': 'Exterior & Pergolas',
  },

  // ── Product descriptions (productCategoriesData) ──────────────────────────────
  productDescriptions: {
    'Cuisines sur Mesure': 'Atölye Mutfak & Soprano — 31 models, all styles and finishes',
    'Appareils Sanitaires': 'Bathtubs, basins and WCs with clean architectural lines',
    'Meubles de Salle de Bain': 'Kobos collections — elegance and bespoke functionality',
    'Robinetterie de Luxe': 'Sophisticated finishes — brushed gold, matte black, polished chrome',
    'Systèmes de Douche': 'Premium shower solutions — columns, enclosures and exceptional trays',
    'Produits Complémentaires': 'Accessories and complements to elevate your bathroom',
    'Accessoires de Bain': 'Mirrors, towel rails and design accessories for your space',
    'Menuiserie': 'Doors, PVC & ALU windows, roller shutters and guillotine systems',
    'Extérieur & Pergolas': 'Motorised pergolas, ZIP blinds and guillotine glazing for your terraces',
  },

  // ── Colors (product colors in collections) ────────────────────────────────────
  colors: {
    'Blanc': 'White', 'Ivoire': 'Ivory', 'Crème': 'Cream', 'Beige': 'Beige',
    'Sable': 'Sand', 'Latte': 'Latte', 'Caramel': 'Caramel', 'Bone': 'Bone',
    'Gris': 'Grey', 'Greige': 'Greige', 'Gris Clair': 'Light Grey',
    'Gris Foncé': 'Dark Grey', 'Argent': 'Silver', 'Perle': 'Pearl',
    'Fumée': 'Smoke', 'Taupe': 'Taupe',
    'Noir': 'Black', 'Anthracite': 'Anthracite',
    'Brun': 'Brown', 'Moka': 'Mocha', 'Café': 'Coffee', 'Cotto': 'Cotto',
    'Or': 'Gold', 'Doré': 'Golden', 'Cuivre': 'Copper',
    'Bleu': 'Blue', 'Marine': 'Navy', 'Vert': 'Green',
    'Rouge': 'Red', 'Bordeaux': 'Bordeaux', 'Rose': 'Rose',
    'Naturel': 'Natural', 'Mix': 'Mix', 'Décofon': 'Décofon',
    'Pierre': 'Stone', 'Sauge': 'Sage', 'Kaki': 'Khaki',
    'Chêne': 'Oak', 'Noyer': 'Walnut', 'Venge': 'Wenge',
  },

  // ── Surfaces ──────────────────────────────────────────────────────────────────
  surfaces: {
    'Mat': 'Matte',
    'Brillant': 'Glossy',
    'Full Lappato': 'Full Lappato',
    'Lappato': 'Lappato',
    'Poli': 'Polished',
    'Satiné': 'Satin',
  },

  // ── Collections Showcase (HomePage) ───────────────────────────────────────────
  collectionsShowcase: {
    title: 'Collections Signature',
    subtitle: 'Drag to explore our most iconic creations',
    viewAll: 'View all our collections',
  },

  // ── Catalogue page ───────────────────────────────────────────────────────────
  catalogue: {
    title: 'OUR CATALOGUES',
    subtitle: 'Download our catalogues to discover our full range of collections',
  },

  // ── Shop pages (category list + detail templates) ──────────────────────────────
  shop: {
    home: 'Home',
    all: 'All',
    allNeutral: 'All',
    allFem: 'All',
    filters: 'FILTERS',
    clearAll: 'Clear all',
    close: 'Close',
    reset: 'Reset',
    resetFilters: 'Reset filters',
    productNotFound: 'Product not found',
    modelNotFound: 'Model not found',
    noProductsFound: 'No products found.',
    noModelsFound: 'No models found.',
    noCollectionsFound: 'No collections found.',
    productsFoundCount_one: '{{count}} product found',
    productsFoundCount_other: '{{count}} products found',
    modelsFoundCount_one: '{{count}} model found',
    modelsFoundCount_other: '{{count}} models found',
    brand: 'Brand',
    requestQuote: 'Request a quote',
    productSheet: 'Product sheet (.rar)',
    similarProducts: 'SIMILAR PRODUCTS',
    discover: 'Discover',
    category: 'CATEGORY',
    color: 'COLOR',
    seriesCollection: 'SERIES / COLLECTION',
    productType: 'PRODUCT TYPE',
    colorFinish: 'COLOR / FINISH',
  },

  // ── Sanitaire pages ──────────────────────────────────────────────────────────
  sanitaire: {
    backLink: 'Back to bathroom',
    description: "Premium quality sanitary product, combining contemporary design and durability. For more information or to request a quote, contact our showroom.",
  },

  // ── Tamamlayici (complementary products) pages ──────────────────────────────
  tamamlayici: {
    pageTitle: 'BATHROOM ACCESSORIES',
    pageTitleCase: 'Bathroom accessories',
    backLink: 'Back to accessories',
    description: "Premium quality bathroom accessory. For more information or to request a quote, contact our showroom.",
  },

  // ── Armaturler (faucets) pages ───────────────────────────────────────────────
  armaturler: {
    pageTitle: 'FAUCETS & SHOWERS',
    pageTitleCase: 'Faucets & Showers',
    backLink: 'Back to faucets',
    description: 'Premium quality faucet, designed to combine aesthetics and performance. For more information or to request a quote, contact our showroom.',
  },

  // ── Dus (shower systems) pages ───────────────────────────────────────────────
  dus: {
    pageTitle: 'SHOWER SYSTEMS',
    pageTitleCase: 'Shower systems',
    backLink: 'Back to shower systems',
    description: "Premium quality shower system, designed to combine aesthetics and performance. For more information or to request a quote, contact our showroom.",
  },

  // ── Aksesuar (bath accessories) pages ────────────────────────────────────────
  aksesuar: {
    pageTitle: 'BATHROOM ACCESSORIES',
    pageTitleCase: 'Bathroom Accessories',
    backLink: 'Back to accessories',
    description: "Premium quality bathroom accessory, combining design and functionality. For more information or to request a quote, contact our showroom.",
  },

  // ── Cuisine (custom kitchens) pages ──────────────────────────────────────────
  cuisine: {
    pageTitle: 'CUSTOM KITCHENS',
    pageTitleCase: 'Kitchens',
    search: 'SEARCH',
    searchPlaceholder: 'Model name...',
    brand: 'BRAND',
    style: 'STYLE',
    finish: 'FINISH',
    backLink: 'Back to kitchens',
    sameStyle: 'IN THE SAME STYLE',
  },

  // ── Kobos (bathroom furniture) pages ─────────────────────────────────────────
  kobos: {
    pageTitle: 'BATHROOM FURNITURE',
    pageTitleCase: 'Bathroom Furniture',
    availableCount_one: '{{count}} collection available',
    availableCount_other: '{{count}} collections available',
    searchPlaceholder: 'Collection name...',
    notFound: 'Collection not found.',
    backLinkArrow: 'Back to furniture',
    photosCount: '{{count}} photos',
    categoryLabel: 'Bathroom furniture · Kobos',
    availableDimensions: 'AVAILABLE DIMENSIONS',
    finishes: 'FINISHES',
    material: 'MATERIAL',
    otherCollections: 'OTHER COLLECTIONS',
  },

  // ── Soprano (custom kitchens) pages ──────────────────────────────────────────
  soprano: {
    pageTitle: 'CUSTOM KITCHENS',
    pageTitleCase: 'Custom Kitchens',
    availableCount_one: '{{count}} model available',
    availableCount_other: '{{count}} models available',
    notFound: 'Model not found.',
    backLinkArrow: 'Back to kitchens',
    photosCount: '{{count}} photos',
    categoryLabel: 'Custom kitchen · Soprano',
    availableFinishes: 'AVAILABLE FINISHES',
    manufacturing: 'MANUFACTURING',
    manufacturingDetail: 'Made to measure · Matte lacquer, wood, premium MDF',
    otherModels: 'OTHER MODELS',
  },

  // ── Exterieur (pergolas) pages ───────────────────────────────────────────────
  exterieur: {
    subtitle: 'PERGOLAS & SUN PROTECTION',
    viewAll: 'View all',
    productCount_one: '{{count}} product',
    productCount_other: '{{count}} products',
    specs: 'CHARACTERISTICS',
    otherProducts: 'OTHER PRODUCTS',
  },

  // ── Menuiserie (joinery) pages ───────────────────────────────────────────────
  menuiserie: {
    pageTitle: 'JOINERY',
    pageTitleCase: 'Joinery',
    subtitle: 'Windows, doors and bespoke solutions',
    productCount_one: '{{count}} product',
    productCount_other: '{{count}} products',
    clearAll: 'Clear all',
    viewMore: 'View more',
    viewLess: 'View less',
    specs: 'CHARACTERISTICS',
    otherProducts: 'OTHER PRODUCTS',
    categoryNotFound: 'Category not found.',
    backLink: 'Back to joinery',
    searchModelPlaceholder: 'Search a model...',
  },

  // ── Aderka (pivot doors) pages ───────────────────────────────────────────────
  aderka: {
    pageTitle: 'ALUMINIUM PIVOT DOORS',
    pageSubtitle: 'Aderka Door Systems — 4 series, 19 models',
    modelsCount: '{{count}} models',
    discoverSeries: 'Discover the series',
    seriesDescriptions: {
      exclusive: 'Clean architectural lines',
      stoneline: 'Natural stone-effect finish',
      elegance: 'Contemporary elegance — 10 models',
      woodline: 'Wood texture on aluminium frame',
    },
    pageTitleFallback: 'PIVOT DOORS',
    modelCount_one: '{{count}} model',
    modelCount_other: '{{count}} models',
    doorSystemsSuffix: 'Aderka Door Systems',
    allSeries: 'All series',
    viewModel: 'View model',
    breadcrumbHome: 'Home',
    breadcrumbPivotDoors: 'Pivot Doors',
    notFound: 'Model not found.',
    backToSeries: 'Back to series',
    material: 'Material',
    finish: 'Finish',
    style: 'Style',
    dimensions: 'Dimensions',
    series: 'Series',
    usage: 'Usage',
    materialAluminium: 'Aluminium',
    dimensionsCustom: 'Custom',
    usageExterior: 'Exterior',
    requestQuote: 'Request a quote',
    seriesLinkPrefix: 'Series',
    sameRangeModels: 'MODELS FROM THE SAME RANGE',
    seriesFinish: {
      exclusive: 'Matte lacquer',
      stoneline: 'Natural stone effect',
      elegance: 'Elegant modern',
      woodline: 'Authentic wood effect',
    },
    seriesStyle: {
      exclusive: 'Architectural',
      stoneline: 'Mineral',
      elegance: 'Contemporary',
      woodline: 'Natural',
    },
    seriesLongDescriptions: {
      exclusive: "The Exclusive series embodies the alliance between architectural rigour and absolute sophistication. Its clean lines and controlled proportions make it a signature feature for high-end entrances. Every model is designed to stand out as a centrepiece, combining strength with timeless aesthetics.",
      stoneline: "Stoneline reinvents the pivot door with a remarkably authentic natural stone-effect finish. This unique surface treatment gives every door a strong mineral character, turning the entrance into an artistic statement while retaining all the technical performance of aluminium.",
      elegance: "The Elegance series declines the pivot door into ten distinct expressions, all united by the same guiding thread: contemporary elegance without ostentation. Refined shapes, subtle material contrasts and a meticulous finish make every model an entrance that leaves a lasting impression.",
      woodline: "Woodline combines the warmth of wood with the unmatched performance of aluminium. Its authentic wood texture is achieved through a high-definition thermal lacquering process that faithfully reproduces the grain and tones of natural wood. Ideal for modern interiors seeking warmth without maintenance constraints.",
    },
    features: {
      aluminium: { label: 'High-strength aluminium', sub: 'Reinforced aluminium profiles' },
      pivotSystem: { label: 'High-performance pivot system', sub: '360° rotation — concealed pivot' },
      insulation: { label: 'Thermal & acoustic insulation', sub: 'Thermal break technology' },
      customFinish: { label: 'Bespoke finishes', sub: 'Choice of RAL colours' },
    },
  },

  // ── Product detail page (tile products) ──────────────────────────────────────
  productDetail: {
    notFound: 'Product not found',
    backToCollections: 'Back to collections',
    faceAlt: 'Face {{index}}',
    viewAlt: 'View {{index}}',
    optionsTitle: 'Product options',
    sizeLabel: 'Size',
    colorLabel: 'Colour',
    finishLabel: 'Finish',
    technicalSpecsTitle: 'Technical characteristics',
    specsPendingText: 'Detailed technical characteristics will be available soon.',
    specsPendingContact: 'For any information, contact us.',
    packagingTitle: 'Packaging',
    documentsTitle: 'Documents',
    requestQuote: 'Request a quote',
  },

  // ── Products page ────────────────────────────────────────────────────────────
  products: {
    title: 'OUR PRODUCTS',
    subtitle: 'Premium quality products sourced from global partners',
    all: 'All',
    explore: 'EXPLORE',
    ctaText: 'Looking for a specific product? Contact our team directly.',
    getInTouch: 'GET IN TOUCH',
  },

  // ── About page ───────────────────────────────────────────────────────────────
  about: {
    title: 'ABOUT US',
    whoWeAre: 'Who We Are',
    paragraph1: 'SRA Global Trading is a Dubai-based company specialising in the sourcing, supply and distribution of premium quality products across the construction, interior design and general trading sectors.',
    paragraph2: "Located in the heart of Dubai's business district at Latifa Tower on Sheikh Zayed Road, we are ideally positioned to serve markets across the Middle East, Africa and beyond. Our strategic location gives us access to a vast network of international suppliers and logistics partners.",
    paragraph3: 'We take pride in delivering excellence at every stage — from product selection and quality control to timely delivery and after-sales support. Our experienced team brings decades of combined expertise in trading and procurement.',
    ourValues: 'OUR VALUES',
    values: {
      excellence: { name: 'Excellence', desc: 'We source only the highest quality products from certified suppliers worldwide.' },
      integrity: { name: 'Integrity', desc: 'Transparency and honesty are the foundation of every partnership we build.' },
      partnership: { name: 'Partnership', desc: 'We invest in long-term relationships with clients and suppliers alike.' },
      innovation: { name: 'Innovation', desc: 'We constantly evolve our product range to meet the demands of modern markets.' },
    },
    readyToWork: 'Ready to work with us?',
    contactUs: 'CONTACT US',
  },

  // ── Contact page ─────────────────────────────────────────────────────────────
  contact: {
    title: 'CONTACT US',
    subtitle: 'Our team is available to answer all your enquiries',
    ourDetails: 'Our Details',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    businessHours: 'Business Hours',
    closed: 'Closed',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    sendMessage: 'Send us a Message',
    successMessage: 'Your message has been sent successfully. We will get back to you shortly.',
    error: 'An error occurred. Please try again or contact us directly.',
    fullName: 'Full Name',
    subject: 'Subject',
    message: 'Message',
    sending: 'Sending...',
    sendMessageBtn: 'Send Message',
  },

  // ── Realisations page ──────────────────────────────────────────────────────────
  realisations: {
    pageTitle: 'Our Projects',
    pageSubtitle: 'Exceptional projects, at the heart of Africa',
    historyTitle: 'A place rich in history',
    zonesTitle: 'Four zones, a major urban hub',
    imagesTitle: 'The project in pictures',
    progressTitle: 'Construction progress',
    progressSubtitle: 'Drag to follow the progress of the works',
    developedBy: 'Developed by',
    downloadBrochure: 'Download the brochure',
  },
};

export default en;
